import React, { useLayoutEffect, useRef } from 'react';
import { gsap } from 'gsap';
import useReducedMotion from '../hooks/useReducedMotion';
import useScrollLock from '../hooks/useScrollLock';

export default function ProjectPreview({ project, onClose }) {
  const dialog = useRef(null);
  const reduced = useReducedMotion();
  useScrollLock(true);
  useLayoutEffect(() => {
    const element = dialog.current;
    element.showModal();
    const context = gsap.context(() => {
      gsap.from('.project-preview__content', { y: reduced ? 0 : 24, opacity: 0, duration: reduced ? 0 : .45, ease: 'power3.out' });
    }, dialog);
    return () => { context.revert(); element.close(); };
  }, [reduced]);
  return <dialog className="project-preview" ref={dialog} onClose={onClose} onClick={(event) => { if (event.target === dialog.current) dialog.current.close(); }} aria-label={`${project.title} project preview`}>
    <div className="project-preview__content"><button type="button" className="project-preview__close" onClick={() => dialog.current.close()} aria-label="Close project preview">×</button>
      <img src={project.cover} alt={`${project.title} design preview`} /><div><h2>{project.title}</h2><span>{project.category}</span></div>
    </div>
  </dialog>;
}
